/* eslint-disable @typescript-eslint/no-explicit-any */
import { useClient } from '@composables/use-clients';
import { PostRequestArgsType } from '@api/v1/types';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type TenantInvitationCodeSerializer = {
  emails: string[];
  tenantInvitationCodes: Array<Record<string, any>>;
};

export type PostTenantInvitationCodePayloadType = (
  Pick<TenantInvitationCodeSerializer, 'emails'>
);
export type PostTenantInvitationCodeResponseType = (
  Pick<TenantInvitationCodeSerializer, 'tenantInvitationCodes'>
);

export const apiFetchTenantInvitationCodes = async ({
  query = {},
  errorConfig = {},
  callbacks = {},
} = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.tenantInvitationCodes(),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiRequestTenantInvitationCode = async ({
  payload,
  errorConfig = {},
  callbacks = {},
}: PostRequestArgsType<PostTenantInvitationCodePayloadType>) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.tenantInvitationCodes(),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiRevokeTenantInvitationCode = async ({
  tenantInvitationCodeId,
  errorConfig = {},
  callbacks = {},
}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.delete({
      url: urls.v1.tenantInvitationCodes({
        tenantInvitationCodeId,
      }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
